<template>
  <div class="container">
    <div class="goods-container">
      <el-page-header @back="goBack" :content="title"> </el-page-header>

      <div style="margin-top: 30px">
        <el-form size="small" ref="form" :model="form" label-width="100px">
          <el-form-item label="账户名称" required>
            <el-input v-model="form.name" placeholder="请输入账户名称" style="width: 200px"></el-input>
          </el-form-item>

          <el-form-item label="所属校区" required>
            <el-select v-model="form.value" multiple placeholder="请选择">
              <el-option v-for="item in school_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="账户类型" required>
            <el-select v-model="form.type">
              <el-option label="现金" :value="1"></el-option>
              <el-option label="银行存款" :value="2"></el-option>
              <el-option label="虚拟货币" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button @click="Cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEducationalInstitutionCampusList,
  addOrUpdateOtherEducationalInstitutionAccount,
} from "@/api/educational";

export default {
  name: "payaccount",
  data() {
    return {
      school_list: [],
      title: "",
      form: {
        name: "",
        value: [],
        remark: "",
        type: "",
      },
    };
  },
  mounted() {
    this.getEducationalInstitutionCampusList();

    if (this.$route.query.cmd == "create") {
      console.log("新建收款账户");
      this.title = "新增收款账户";
    } else {
      console.log("编辑收款账户");
      this.title = "修改收款账户";

      this.form = {
        name: this.$route.query.account.name,
        remark: this.$route.query.account.remark,
        type: this.$route.query.account.type,
      };

      this.form.value = [];

      for (
        let k = 0;
        k < this.$route.query.account.campusAccountAutArr.length;
        k++
      ) {
        this.form.value.push(
          this.$route.query.account.campusAccountAutArr[k]
            .educational_institution_campus_id
        );
      }
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "account",

      });
    },

    //所得账号所负责的校区
    getEducationalInstitutionCampusList() {
      getEducationalInstitutionCampusList().then((res) => {
        console.log("获得分校列表");
        console.log(res);
        this.school_list = res.educational_institution_campus_list;
      });
    },

    onSubmit() {
      console.log(this.form);

      if (this.$route.query.cmd == "create") {
        console.log("新建收款账户");
        addOrUpdateOtherEducationalInstitutionAccount({
          campus_ids: JSON.stringify(this.form.value),
          name: this.form.name,
          type: this.form.type,
          remark: this.form.remark,
        }).then((res) => {
          console.log("添加学校收款账户");
          console.log(res);
          if (res.is_created) {
            this.$message.success("添加账户成功");
            this.$router.push({
              name: "account",

            });
          }
        });
      } else {
        console.log("编辑收款账户");
        addOrUpdateOtherEducationalInstitutionAccount({
          educationalInstitutionAccountId: this.$route.query.account.id,
          campus_ids: JSON.stringify(this.form.value),
          name: this.form.name,
          type: this.form.type,
          remark: this.form.remark,
        }).then((res) => {
          console.log("更新学校收款账户");
          console.log(res);
          if (res.is_update) {
            this.$message.success("更新账户成功");
            this.$router.push({
              name: "account",

            });
          }
        });
      }
    },

    Cancel() {
      this.$router.push({
        name: "account",

      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1000px;

  overflow-y: scroll;

  .goods-container {
    border-radius: 5px;
    margin: 10px;
    padding: 15px;
    background-color: #ffffff;

    .title {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
